<script setup lang="ts">
import { computed } from 'vue'
import Dropdown from '../../../../components/Dropdown/Dropdown.vue'

const props = defineProps<{
	label: string
	options: Array<{ value: string; label: string }>
	value: string | undefined
	disabled?: boolean
}>()

defineEmits<{
	(e: 'input', value: string): void
}>()

const boxStyle = computed(() => {
	return props.value ? 'border-blue-tints bg-blue-tint-4' : 'border-gray-medium bg-light-2'
})
</script>

<template>
	<div
		:class="boxStyle"
		class="p-1 gap-4 flex border rounded"
	>
		<p class="flex !m-0 !min-w-8 items-center text-sm font-medium">
			{{ label }}
		</p>

		<Dropdown
			:options="options"
			:value="value"
			:disabled="disabled"
			@input="$emit('input', $event)"
			class="!w-3/4 bg-white-neutral rounded-md"
		/>
	</div>
</template>

<style scoped>
:deep(.container__dropdown__component__default) {
	border-radius: 0;
}

:deep(.label__current_label) {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
</style>
